import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {
    AcabimProject,
    AcabimProjectBuildingStatus,
    AcabimSolution, GenericOption,
    ProjectApiService,
    Status
} from '@cas-hub/acabim-common-client';
import {FinancialChartAccount} from '../../../_models/financial-account.model';

@Component({
    selector: 'acabim-admin-advanced',
    templateUrl: './advanced.component.html',
    styleUrls: ['./advanced.component.scss']
})
export class AdvancedComponent implements OnInit {
    // advancedAccountForm: any;
    isLoading = false;
    projects: AcabimProject[] = [];
    projectOptions: GenericOption[] = [];
    advancedForm: FormGroup = new FormGroup({
        selectedProject: new FormControl(null)
    });
    _accountId?: string;
    _accountName?: string;
    selected: { projectId: string, accountId: string, accountName: string } | null = null;

    @Input() set accountDetail(value: FinancialChartAccount) {
        this.selected = null;
        if(value) {
            this._accountId = value.id.toString();
            this._accountName = value.name.toString();
            const options = {
                filterStatus: Status.active,
                filterSolution: AcabimSolution.ACAFM,
                filterBuildingStatus: AcabimProjectBuildingStatus.BuildingAvailable
            };
            this.projectService.getAllProjects(undefined, options, true)
                .subscribe((val: any) => {
                    this.projects = val as AcabimProject[];
                    this.projectOptions = this.projects.map(pr => {
                        return {
                            value: pr.id,
                            label: pr.name
                        } as GenericOption;
                    });
                    this.selectProjectService.selectedProject$.subscribe(project => {
                        const index = val.findIndex((ele: { id: string; }) => ele.id === project?.id);
                        if (index !== -1) {
                            this.advancedForm.get('selectedProject')?.patchValue({value: this.projectOptions[index].value, label: this.projectOptions[index].label})
                        }
                    })   
                    if (this.advancedForm && this._accountId && this._accountName) {
                        this.advancedForm.get('selectedProject')?.valueChanges.subscribe(change => {
                            this.selected = {
                                projectId: change.value,
                                accountId: this._accountId ?? '',
                                accountName: this._accountName ?? ''
                            }
                        });
                    }
                });
        }

    }

    constructor(private readonly projectService: ProjectApiService, readonly selectProjectService: ProjectApiService) {
        // this.advancedAccountForm = new FormGroup({
        //     contingencyFund: new FormControl(null, Validators.required)
        // });
    }

    ngOnInit(): void {
    }

}
